import React from 'react';
import { Mail, Smartphone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { appMeta } from '@/config/iphonefastflip';

const Footer: React.FC = () => (
  <footer className="border-t border-white/[0.08] bg-[#070a10]/80">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <div className="mb-4 flex items-center gap-3">
          <div className="grid h-10 w-10 place-items-center rounded-xl bg-gradient-to-br from-blue-500 to-cyan-400">
            <Smartphone className="h-5 w-5 text-white" />
          </div>
          <div>
            <p className="font-black text-white">Alterolis</p>
            <p className="text-xs text-slate-500">{appMeta.name}</p>
          </div>
        </div>
        <p className="max-w-md text-sm leading-6 text-slate-500">
          Narzędzie do przeglądania ofert iPhone’ów, porównywania ich z własnym cennikiem i szybszego wyszukiwania potencjalnie opłacalnych okazji.
        </p>
      </div>

      <div>
        <p className="mb-4 text-sm font-bold text-white">Produkt</p>
        <div className="flex flex-col gap-3 text-sm text-slate-500">
          <Link to="/features" className="hover:text-white">Funkcje</Link>
          <Link to="/changelog" className="hover:text-white">Dziennik zmian</Link>
          <a href={appMeta.webUrl} className="hover:text-white">Aplikacja webowa</a>
          <a href="/#plany" className="hover:text-white">Plany</a>
        </div>
      </div>

      <div>
        <p className="mb-4 text-sm font-bold text-white">Informacje</p>
        <div className="flex flex-col gap-3 text-sm text-slate-500">
          <Link to="/support" className="hover:text-white">Pomoc</Link>
          <Link to="/privacy" className="hover:text-white">Prywatność</Link>
          <a href={`mailto:${appMeta.supportEmail}`} className="flex items-center gap-2 hover:text-white">
            <Mail className="h-4 w-4" /> {appMeta.supportEmail}
          </a>
        </div>
      </div>
    </div>

    <div className="border-t border-white/[0.06] px-4 py-5 text-center text-xs text-slate-600">
      © {new Date().getFullYear()} Alterolis. iPhoneFastFlip nie jest powiązany z Apple, OLX, Allegro ani Vinted.
    </div>
  </footer>
);

export default Footer;
